import React from 'react';

function IndexGrid({ images = [], closeView }) {
  return (
    <div className="index-grid-container">
      <div className="index-grid-header">
        <button onClick={closeView} className="index-close-button">Close</button>
      </div>
      <div className="index-grid">
        {images.map((image, index) => (
          <div key={index} className="index-grid-item">
            <img
              src={process.env.PUBLIC_URL + image.src}
              alt={`Index thumbnail ${index + 1}`}
              loading="lazy"
              onError={(e) => { e.target.style.display='none'; }}
            />
            {/* Optional: Add type label (originals/b&w) */}
            {/* <span className="index-item-type">{image.type}</span> */}
          </div>
        ))}
        {images.length === 0 && <p>No images found for index.</p>}
      </div>
    </div>
  );
}

export default IndexGrid; 